import { db } from "@/firebase";
import { Role } from "@/model/entities";
import { doc, getDoc } from "firebase/firestore";

export async function fetchUserRole(uid: string): Promise<Role | null> {
    const userDoc = doc(db, "users", uid);
    const userSnapshot = await getDoc(userDoc);
    if (userSnapshot.exists()) {
      const userData = userSnapshot.data();
      return userData.role as Role;
    }
    return null;
  }